import builderSlugs from "../../../config/builder-slugs.json";

export function resolveBuilderSlug(market, sourceSlug) {
  return builderSlugs[market]?.[sourceSlug] || sourceSlug;
}

export function resolveMarketPath(marketContext, path) {
  const normalizedPath = String(path || "").replace(/^\//, "");
  const match = normalizedPath.match(/^(builder\/)([^/]+)(\/.*)?$/);
  if (!match) return normalizedPath;

  const [, prefix, sourceSlug, suffix = "/"] = match;
  return `${prefix}${resolveBuilderSlug(marketContext.market, sourceSlug)}${suffix}`;
}

export function getBuilderUrl(marketContext, sourceSlug = "", suffix = "/") {
  const baseUrl = marketContext.services.woocommerceBaseUrl;
  const slug = resolveBuilderSlug(marketContext.market, sourceSlug);
  const path = slug ? `/builder/${slug}${suffix}` : `/builder${suffix}`;
  return `${baseUrl}${path}`;
}
